module.exports = __webpack_public_path__ + "static/cherryGrove.47a1c1dc.jpg";